var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEduBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 572,
    viewBox: "0 0 572 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.007 242.86L332.262 240.508L314.072 184.408L306.817 186.76L325.007 242.86Z",
    fill: "#6977F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.006 242.86L332.261 240.507L331.789 251.414L325.006 242.86Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.788 251.414L332.01 246.29L328.602 247.395L331.788 251.414Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.431 342.907V335.32H367.714V330.125H265.844V348.102H367.714V342.907H358.431Z",
    fill: "#1D288E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.596 335.32H280.869V342.905H360.596V335.32Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M346.179 325.244V318.119H350.827V313.238H286V330.126H350.827V325.244H346.179Z",
    fill: "#384BF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M346.18 318.119H291.109V325.244H346.18V318.119Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360.453 299.619L358.156 301.041L359.98 304.075L351.123 309.333L349.335 306.502L347.014 307.938L370.618 345.924L384.057 337.607L360.453 299.619Z",
    fill: "#1D288E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M359.98 304.074L359.983 304.077L351.123 309.332L370.168 339.98L378.924 334.561L359.98 304.074Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M440.684 361.879L440.684 345.771L254.001 345.771L254.001 361.879L440.684 361.879Z",
    fill: "#6977F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M448.735 266.271H432.631V506.085H448.735V266.271Z",
    fill: "#818181"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M339.08 266.271H322.977V506.085H339.08V266.271Z",
    fill: "#818181"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M482.58 274.325L482.58 258.217L186.851 258.217L186.851 274.325L482.58 274.325Z",
    fill: "#6977F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M482.582 506.084L482.582 489.977L199.81 489.977L199.81 506.084L482.582 506.084Z",
    fill: "#818181"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.756 506.084L214.756 489.977L193.813 489.977L193.813 506.084L214.756 506.084Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M491.375 506.085L491.375 489.977L470.432 489.977L470.432 506.085L491.375 506.085Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M381.466 421.166V472.855H363.355V439.235C363.355 429.256 371.464 421.166 381.466 421.166Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M499.957 421.166V472.855H518.068V439.235C518.068 429.256 509.96 421.166 499.957 421.166Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M462.893 329.399H455.221V310.797C455.221 302.846 448.738 296.378 440.768 296.378C432.799 296.378 426.317 302.846 426.317 310.797V329.399H418.645V310.797C418.641 298.626 428.567 288.725 440.767 288.725C452.967 288.725 462.893 298.626 462.893 310.797V329.399Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M506.084 472.854H375.451V385.614C375.451 349.628 404.694 320.453 440.769 320.453C476.841 320.453 506.086 349.626 506.086 385.614V472.854H506.084Z",
    fill: "#1D288E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M444.587 373.742H436.948C416.747 373.742 400.369 390.079 400.369 410.233V454.345H481.164V410.233C481.165 390.079 464.788 373.742 444.587 373.742Z",
    fill: "#384BF5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M440.769 393.08C449.843 393.08 457.198 385.742 457.198 376.691C457.198 367.639 449.843 360.301 440.769 360.301C431.695 360.301 424.34 367.639 424.34 376.691C424.34 385.742 431.695 393.08 440.769 393.08Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M131.698 358.449H115.51V499.767H131.698V358.449Z",
    fill: "#818181"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1304 232.826V347.151C25.1304 357.564 33.5524 366.014 43.9603 366.044L125.269 366.274V382.469L38.7548 382.225C22.2743 382.18 8.93945 368.799 8.93945 352.312L8.94103 232.826H25.1304Z",
    fill: "#818181"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7688 366.217L51.6445 350.021L162.061 350.351V366.546L51.7688 366.217Z",
    fill: "#6977F7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0921 318.206L24.9043 318.33L25.2332 210.277H41.421L41.0921 318.206Z",
    fill: "#6977F7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7024 505.755L62.5781 489.561L181.319 489.888V506.084L62.7024 505.755Z",
    fill: "#818181"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M186.311 505.92L186.311 489.725L165.259 489.725L165.259 505.92L186.311 505.92Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9492 505.92L81.9492 489.725L60.8974 489.725L60.8974 505.92L81.9492 505.92Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9046 232.826H8.7168V253.888H24.9046V232.826Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M465.898 170.961L445.959 228.947L452.702 231.257L472.641 173.271L465.898 170.961Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M447.557 147.663L442.715 152.887L465.214 173.667L470.056 168.443L447.557 147.663Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M453.647 238.816H446.518V253.55H453.647V238.816Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M443.909 146.252H422.443V153.368H443.909V146.252Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M457.55 252.602H387.912V258.218H457.55V252.602Z",
    fill: "#384BF5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M428.015 139.114C424.082 134.803 417.395 134.488 413.081 138.413L398.526 151.649L412.771 167.26L427.326 154.023C431.639 150.101 431.948 143.425 428.015 139.114Z",
    fill: "#1D288E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M415.384 164.865L401.158 149.276C389.991 143.435 375.916 144.791 366.065 153.75L365.734 154.051L407.329 199.633L407.66 199.331C417.512 190.373 420.172 176.509 415.384 164.865Z",
    fill: "#384BF5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M457.55 226.957H442.215V241.848H457.55V226.957Z",
    fill: "#1D288E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M444.555 156.644C448.335 156.644 451.4 153.585 451.4 149.811C451.4 146.038 448.335 142.979 444.555 142.979C440.774 142.979 437.709 146.038 437.709 149.811C437.709 153.585 440.774 156.644 444.555 156.644Z",
    fill: "#384BF5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M469.275 178.943C473.056 178.943 476.121 175.884 476.121 172.11C476.121 168.336 473.056 165.277 469.275 165.277C465.495 165.277 462.43 168.336 462.43 172.11C462.43 175.884 465.495 178.943 469.275 178.943Z",
    fill: "#384BF5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M367.17 252.225H295.807V257.672H367.17V252.225Z",
    fill: "#818181"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M441.256 307.245C444.265 307.245 446.704 304.806 446.704 301.797C446.704 298.789 444.265 296.35 441.256 296.35C438.248 296.35 435.809 298.789 435.809 301.797C435.809 304.806 438.248 307.245 441.256 307.245Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M198.871 202.652C193.049 188.268 193.992 174.328 193.992 174.328C193.992 174.328 204.373 183.71 210.194 198.094C216.014 212.478 215.073 226.418 215.073 226.418C215.073 226.418 204.692 217.036 198.871 202.652Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M240.872 204.26C232.909 217.584 221.209 225.267 221.209 225.267C221.209 225.267 222.42 211.347 230.384 198.024C238.348 184.701 250.047 177.018 250.047 177.018C250.047 177.018 248.835 190.937 240.872 204.26Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M221.03 167.455C224.384 154.879 232.053 145.996 232.053 145.996C232.053 145.996 234.284 157.504 230.93 170.081C227.577 182.658 219.907 191.541 219.907 191.541C219.907 191.541 217.675 180.031 221.03 167.455Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M209.125 169.763C206.587 161.715 207.696 154.197 207.696 154.197C207.696 154.197 212.922 159.727 215.46 167.775C217.998 175.823 216.889 183.341 216.889 183.341C216.889 183.341 211.664 177.811 209.125 169.763Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M218.043 234.792C217.138 211.96 220.059 187.158 220.088 186.91L220.941 187.011C220.911 187.259 217.998 211.995 218.9 234.759L218.043 234.792Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M217.994 233.245C216.122 227.353 213.56 224.611 213.535 224.584L214.157 223.994C214.266 224.109 216.875 226.887 218.812 232.986L217.994 233.245Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M218.843 233.3L218.072 232.924C218.403 232.25 221.242 224.697 222.697 220.797L223.502 221.096C223.329 221.557 219.275 232.42 218.843 233.3Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M219.095 197.074C219.086 191.953 215.913 181.79 215.881 181.688L216.7 181.432C216.832 181.854 219.944 191.822 219.953 197.073L219.095 197.074Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M224.932 259.852H212.458C207.637 259.852 203.597 256.221 203.106 251.447L199.674 224.205H237.227L234.297 251.311C233.871 256.144 229.805 259.852 224.932 259.852Z",
    fill: "#384BF5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M239.697 222.809H197.205V225.602H239.697V222.809Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduBlue);
export default __webpack_public_path__ + "static/media/eduBlue.e52874887400964b453a36ed1c40bc4f.svg";
export { ForwardRef as ReactComponent };